<template>
    <CModal
        :title="titleComponent"
        :show="showComponent"
        :color="colorComponent"
        :size="sizeComponent"
    >
        <CForm ref="formAddPhoneToBlacklist" @submit="formSubmit($event, 'addPhoneToBlacklist')">
            <CInput
                :isValid="checkIfFormValid({
                    formName:'addPhoneToBlacklist',
                    fieldName:'phone'
                })"
                :value.sync="$v.forms.addPhoneToBlacklist.phone.$model"
                :label="$t('phone')"
                :disables="true"
            />
            <!-- <CTextarea
                :isValid="checkIfFormValid({
                    formName:'addPhoneToBlacklist',
                    fieldName:'reason'
                })"
                :value.sync="$v.forms.addPhoneToBlacklist.reason.$model"
                :label="$t('reason')"
                :disables="true"
            /> -->
            <CSelect
                :isValid="
                    checkIfFormValid({
                        formName: 'addPhoneToBlacklist',
                        fieldName: 'reason',
                    })
                "
                :value.sync="$v.forms.addPhoneToBlacklist.reason.$model"
                :label="$t('reason')"
                :disables="true"
                :placeholder="'Select type'"
                :options="[
                    { label: 'Low', value: 'Low' },
                    { label: 'Error', value: 'Error' },
                    { label: 'Manual Lock', value: 'Manual Lock' },
                    { label: 'Complaint', value: 'Complaint' },
                ]"
            />

            <ButtonLoading
                type="submit"
                :block="true"
                color="primary"
                :loading="forms.addPhoneToBlacklist._loading"
            >
                <span>{{ $t('Save') }}</span>
            </ButtonLoading>

        </CForm>
        <template #footer>
            <CButton color="secondary" @click="closeModal()">
                {{ $t("Cancel") }}
            </CButton>
            <ButtonLoading color="success" @click="executeSubmitForm" :loading="forms.addPhoneToBlacklist._loading">
                {{ $t("Save") }}
            </ButtonLoading>
        </template>
    </CModal>
</template>

<script>
import formMixin from '~/mixins/form';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators"
import ButtonLoading from '~/components/ButtonLoading.vue';
export default {
    name: "AddEmailToBlacklistModal",
    mixins: [formMixin, validationMixin],
    components: {
        ButtonLoading
    },
    props:{
        title: String,
        show: Boolean,
        color: String,
        size: String
    },

    data(){
        return {
            titleComponent: null,
            showComponent:false,
            colorComponent: "primary",
            sizeComponent: "lg",

            forms:{
                addPhoneToBlacklist:{
                    phone: null,
                    reason: null,
                    _loading: false,
                },
            }
        }
    },

    validations:{
        forms:{
            addPhoneToBlacklist:{
                phone:{
                    required
                },
                reason:{
                    required
                }
            }
        }
    },

    watch:{
        title(){
            this.titleComponent = this.title;
        },
        show(){
            this.showComponent = this.show;
            if(!this.show){
                this.resetForm('addPhoneToBlacklist');
                this.$v.$reset();
            }
        },
        color(){
            this.colorComponent = this.color;
        },
        size(){
            this.sizeComponent = this.size;
        },

        showComponent(){
            this.$emit('update:show',this.showComponent);
        },
    },

    methods:{
        closeModal(){
            this.showComponent = false;
        },


        async formSubmit(e, formName){
            e.preventDefault();
            let response = await this.sendForm({ 
                formName , 
                url: '/headers.api/phones/blacklist'
            });
            this.showComponent = false;

            this.$emit('submit',response);
        },

        executeSubmitForm(){
            this.$refs.formAddPhoneToBlacklist.requestSubmit();
        }
    },

    mounted(){
        this.titleComponent = this.title;
        this.showComponent = this.show;
        this.colorComponent = this.color;
        this.sizeComponent = this.size;
    },
};
</script>

<style>
</style>